import DepartmentTable from 'components/tables/DepartmentTable';
import { _t } from 'lang';
import DashboardLayout from 'layouts/dashboard-layout/DashboardLayout';
import DashboardPageHeading from 'layouts/dashboard-layout/headers/DashboardPageHeading';
import SettingsSidebar from 'layouts/dashboard-layout/sidebars/settings-sidebar/SettingsSidebar';
import { useNavigate } from 'react-router-dom';
import { ADD_DEPARTMENT_PAGE_PATH } from 'routes/paths';

/**
 * Departments page.
 *
 * @see https://www.figma.com/file/X3Zklb3KjOZFu5wAHgGYoH/Toolio---web-Interface?node-id=302%3A11396
 */
export default function DepartmentsPage() {
  const navigate = useNavigate();

  return (
    <DashboardLayout sidebar={<SettingsSidebar />}>
      <div className="relative h-full p-[20px] pt-0">
        <DashboardPageHeading
          heading={_t('Departments')}
          buttonAction={() => navigate(ADD_DEPARTMENT_PAGE_PATH.original)}
        />
        <DepartmentTable />
      </div>
    </DashboardLayout>
  );
}
